import { Form, FormInstance } from "antd";
import { useCallback } from "react";
import { FormButtons } from "./FormButtons";
import { useExport } from "../hooks/useExport";
import { FloatNumberInput } from "../../../../../components/FloatNumberInput";


type FormItemsProps = {
	form: FormInstance;
	closeModal: (value: boolean) => void;
};

export const FormItems = ({ form, closeModal }: FormItemsProps) => {
	const close = useCallback(() => closeModal(false), [closeModal]);
	const { onExportClicked, isLoading } = useExport(form, close);


	return (
		<>
			<Form
				form={form}
				layout="vertical"
				requiredMark={false}
              className="pt-6 processing-print-form"
			>
				<FloatNumberInput
					disabled={isLoading}
					name="contractNumber"
					label="Account Number"
					form={form}
					className="w-100 mb-4"
					prefix=""
				/>
			</Form>

			<FormButtons
				isDisabled={isLoading}
				onPrint={onExportClicked}
				closeModal={close}
			/>
		</>
	);
};
